import React, { Component }     from 'react';
import urlHandler               from '../../utils/urlHandler';
import settings                 from '../../utils/settings';
import permissions              from '../../utils/permissions';
import SamplesControl           from './SamplesControl';
import SidebarControl           from './SidebarControl';
import DemosControl             from './DemosControl';
import _                      from 'underscore';

class FinchForTextControl extends Component {
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onDemoChange = this.onDemoChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);

        this.state = {
            activeDemo: 'entities',
            demoResults: {
                // entityData: null,
                // entities: {
                //     json: null,
                //     entities: null,
                //     segments: null,
                //     keyPhrases: null,
                //     keyPhraseWeights: null,
                //     topicVector: null,
                //     industries: null,
                //     relationships: null,
                //     salience: null
                // },
                // sentiment: {
                //     json: null
                // },
                // summary: {
                //     json: null
                // },
                // tag: {
                //     json: null,
                //     tags: null
                // },
                // translate: {
                //     json: null
                // },
                // headline: {
                //     json: null
                // }
            },
            text: '',
            languageVals: [],
            demoPermissions: {
                entities: false,
                sentiment: false,
                summary: false,
                tag: false,
                translate: false,
                convert: false,
                relationships: false,
                extractArticle: false,
                generateHeadline: false
            }
        }
    }

    componentDidMount() {
        var perms = permissions.getAll();
        if (perms) {
            var entityVals = perms['entities'] || [];

            entityVals.sort((a, b) => {
                const nameA = a.toUpperCase(); // ignore upper and lowercase
                const nameB = b.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            var storedTypes = settings.getValue('types',[]);
            if (!storedTypes || storedTypes.length == 0) {
                entityVals = entityVals.map((name) => {
                    return {
                        name,
                        'selected': true   
                    }
                })   
                settings.setValue('types', entityVals);
            }

            settings.setValue('endpoints', perms['endpoints'] || []);
            settings.setValue('summaryModels', perms['summaryModels'] || []);
            settings.setValue('languageVals', perms['language'] || []);
            settings.setValue('tagModels', perms['taggingModels'] || []);

            if (perms['endpoints']) {

                // If the user has set TIKA_EXTRACTION_URL, allow user to upload files and Tika will
                // be used, if not, then check for permissions on the convert-doc endpoint.

                var convert = !!(window._tikaExtractionUrl) || permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_CONVERT_DOC);
                // if (window._tikaExtractionUrl) {
                //     convert = true;
                // } else {
                //     convert = permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_CONVERT_DOC);
                // }

                // Check if user has correct-text endpoint permissions. If not, set the textCorrections
                // setting to false

                var correctText = true;
                if (!permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_CORRECT_TEXT)) {
                    correctText = false;
                    settings.setValue('textCorrects', []);
                }

                // Set the initial active (selected tab) based on permissions to endpoints that coincide with
                // those tabs

                var activeDemo;
                if (permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)) {
                    activeDemo = 'entities';  
                } else if (permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_DOC_SENTIMENT)) {
                    activeDemo = 'sentiment';  
                } else if (permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_SUMMARIZE)) {
                    activeDemo = 'summary';  
                } else if (permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_TAG)) {
                    activeDemo = 'tag';  
                } else if (permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_TRANSLATE)) {
                    activeDemo = 'translate';  
                } else if (permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_GENERATE_HEADLINE)) {
                    activeDemo = 'headline';  
                }

                this.setState({
                    demoPermissions: {
                        entities: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH),
                        sentiment: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_DOC_SENTIMENT),
                        summary: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_SUMMARIZE),
                        tag: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_TAG),
                        translate: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_TRANSLATE),
                        convert,
                        convert2: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_CONVERT_DOC),
                        informationExtractionPrompts: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_IE_PROMPTS),
                        correctText,
                        salience: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['Salience']),
                        relationships: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['Relationships']),
                        coreferences: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['Coreferences']),
                        returnTranslation: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['ReturnTranslation']),
                        entitySummarization: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['EntitySummarization']),
                        sentenceSalience: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['SentenceSalience']),
                        documentSummarization: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['DocumentSummarization']),
                        extractArticle: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_EXTRACT_ARTICLE),
                        geocodeStreets: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH, ['GeocodeStreets']),
                        generateHeadline: permissions.checkEndpoint(urlHandler.API_ENDPOINT_V1_GENERATE_HEADLINE, ['Headlines']),
                    },
                    activeDemo,
                    languageVals: perms['language'] || []
                }); 
            }
        }
    }

    onChange(results) {
        if (!_.isEqual(results, this.state.demoResults)) {
            this.setState({
                demoResults: results
            })
        }
    }

    onDemoChange(tab) {
        this.setState({
            activeDemo: tab,
            demoResults: {
                // entityData: null,
                // entities: {
                //     json: null,
                //     entities: null,
                //     segments: null,
                //     keyPhrases: null,
                //     keyPhraseWeights: null,
                //     topicVector: null,
                //     industries: null,
                //     relationships: null,
                //     salience: null
                // },
                // sentiment: {
                //     json: null
                // },
                // summary: {
                //     json: null
                // },
                // tag: {
                //     json: null,
                //     tags: null
                // },
                // translate: {
                //     json: null
                // },
                // headline: {
                //     json: null
                // }
            }
        });
    }

    onTextChange(text) {
        this.setState({
            text,
            demoResults: {
                // entityData: null,
                // entities: {
                //     json: null,
                //     entities: null,
                //     segments: null,
                //     keyPhrases: null,
                //     keyPhraseWeights: null,
                //     topicVector: null,
                //     industries: null,
                //     relationships: null,
                //     salience: null
                // },
                // sentiment: {
                //     json: null
                // },
                // summary: {
                //     json: null
                // },
                // tag: {
                //     json: null,
                //     tags: null
                // },
                // translate: {
                //     json: null
                // },
                // headline: {
                //     json: null
                // }
            }
        });
    }

    render() {    
        var hasResults = false;
        var results = this.state.demoResults;

        if (this.state.activeDemo === 'entities') {
            if (results && results.entities && results.entities.entities) {
                hasResults = true;
            }
        } else if (this.state.activeDemo === 'sentiment') {
            if (results && results.sentiment && results.sentiment.json) {
                hasResults = true;
            }
        } else if (this.state.activeDemo === 'summary') {
            if (results && results.summary && results.summary.json) {
                hasResults = true;
            }
        } else if (this.state.activeDemo === 'tag') {
            if (results && results.tag && results.tag.tags) {
                hasResults = true;
            }
        } else if (this.state.activeDemo === 'translate') {
            if (results && results.translate && results.translate.json) {
                hasResults = true;
            }
        } else if (this.state.activeDemo === 'headline') {
            if (results && results.headline && results.headline.json) {
                hasResults = true;
            }
        }

        return (
            <table className='fftcontrol-wrapper'>
                <tbody>
                    <tr>
                        <td>
                            <h1 className='heading-1'>Demo</h1>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="fftcontrol-maincontent">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className="fftcontrol-header"> 
                                                            <div>
                                                                Finch For Text operates on any sort of human generated, natural language text. 
                                                                Paste your text below, select one of the 
                                                                articles shown on the right, or enter a link below to extract text 
                                                                from a known url.
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fftcontrol-body">
                                                            <div>
                                                                <DemosControl onChange={this.onChange} 
                                                                    onDemoChange={this.onDemoChange} 
                                                                    text={this.state.text} 
                                                                    onTextChange={this.onTextChange}
                                                                    permissions={this.state.demoPermissions}
                                                                    results={this.state.demoResults}
                                                                    supportedLanguages={this.state.languageVals}/>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td className="fftcontrol-sidebar">
                                            {hasResults ?
                                                <SidebarControl activeDemo={this.state.activeDemo} 
                                                    results={this.state.demoResults} 
                                                    text={this.state.text}/>
                                                :
                                                    <SamplesControl onChange={this.onTextChange}/>    
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export default FinchForTextControl;
